import * as jquery from 'jquery/dist/jquery.min.js'
import * as popper from '@popperjs/core/dist/umd/popper.min.js'
import * as bootstrap from 'bootstrap'
import * as _ from 'lodash'
import * as async from 'async'
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import * as swal2 from 'sweetalert2'
import * as sprintf from 'sprintf'
// import * as md5 from 'md5.js'
import * as objectHash from '~/node_modules/object-hash/dist/object_hash.js'

window.$ = jquery
window._ = _
window.bootstrap = bootstrap
window.moment = moment
window.tz = tz
window.Swal = swal2
window.sprintf = sprintf
// window.md5 = md5
window.objectHash = objectHash
